import { Component, Input, OnInit } from '@angular/core';
import { Issue } from '../../models/issue';
import { SettingsService } from '../../services/settings.service';

@Component({
  selector: 'app-unseen-indicator',
  templateUrl: './unseen-indicator.component.html',
  styleUrls: ['./unseen-indicator.component.scss']
  })
export class UnseenIndicatorComponent implements OnInit {

  @Input() issue: Issue;

  constructor(private settingsService: SettingsService) { }

  ngOnInit() {
  }

  get isUnseen(): boolean {
    if (!this.issue || !this.issue.updatedAt) {
      return false;
    }

    const updated = new Date(this.issue.updatedAt).getTime();
    let lastViewedTime = 0;
    let lastViewedInAwallTime = 0;

    if (this.issue.lastViewed) {
      lastViewedTime = new Date(this.issue.lastViewed).getTime();
    }

    if (this.issue.lastViewedInAwall) {
      lastViewedInAwallTime = new Date(this.issue.lastViewedInAwall).getTime();
    }

    // Use the latest view date from either Jira or aWall
    const maxViewedTime = Math.max(lastViewedTime, lastViewedInAwallTime);

    // If never viewed (both are null/undefined/0), it is unseen
    if (maxViewedTime === 0) {
      return true;
    }

    return updated > maxViewedTime;
  }
}
